import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

/**
 * Maps classic entity add-edit URLs onto pipeline form routes.
 *
 * Route data:
 *   redirectTo: string[] — path segments; any `:name` is replaced from route params
 *   paramMap?: Record<string, string> — map classic param name → placeholder name
 *     e.g. { quotId: 'leadId' } so `:leadId` reads `params.quotId`
 *   queryParamMap?: Record<string, string> — route param → query param key
 *   queryParams?: Record<string, string> — static query params added to the target
 */
@Component({
  selector: 'app-pipeline-form-redirect',
  template: `<div class="pp-loading"><p>Redirecting…</p></div>`,
})
export class PipelineFormRedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    const data = this.route.snapshot.data || {};
    const template: string[] = Array.isArray(data['redirectTo'])
      ? data['redirectTo']
      : ['/app/pipeline'];
    const paramMap: Record<string, string> = data['paramMap'] || {};
    const queryParamMap: Record<string, string> = data['queryParamMap'] || {};
    const params = this.route.snapshot.params;

    // Reverse map: pipeline placeholder → classic param key
    const classicForPlaceholder: Record<string, string> = {};
    Object.entries(paramMap).forEach(([classic, placeholder]) => {
      classicForPlaceholder[placeholder] = classic;
    });

    const commands = template.map(seg => {
      if (!seg.startsWith(':')) {
        return seg;
      }
      const placeholder = seg.slice(1);
      const classicKey = classicForPlaceholder[placeholder] || placeholder;
      const value = params[classicKey] ?? params[placeholder];
      return value != null ? String(value) : '';
    });

    const queryParams: Record<string, string> = {
      ...(data['queryParams'] || {}),
      ...this.route.snapshot.queryParams,
    };
    Object.entries(queryParamMap).forEach(([routeParam, queryKey]) => {
      const value = params[routeParam];
      if (value != null) {
        queryParams[queryKey] = String(value);
      }
    });

    this.router.navigate(commands, {
      queryParams,
      replaceUrl: true,
    });
  }
}
